import { Device } from 'DeviceUtils';
import { isMagioEnv, isTMCZEnv } from '../options';
import { coComponent, isScriptAllowedRec } from './cookieConsentLoader';

// There is no shadow, eslint error
// eslint-disable-next-line no-shadow
export enum CookieTypes {
    rtbhouse = 'rtbhouse',
    exponea = 'exponea',
    googleRecaptcha = 'google_recaptcha',
    hotjar = 'hotjar',
    tmobileReklamni = 'tmobile_reklamni', // en: tmobile - ads
    facebook = 'facebook',
    tmobileNezbytne = 'tmobile_nezbytne', // en: tmobile - neccessary
    inspectlet = 'inspectlet',
    medallia = 'medallia',
    googleAds = 'google_ads',
    tmobileFunkcni = 'tmobile_funkcni', // en: tmobile functional
    adform = 'adform',
    xaxis = 'xaxis',
    twitter = 'twitter',
    appnexus = 'appnexus',
    seznam = 'seznam',
    tmobileStatisticke = 'tmobile_statisticke', // en: tmobile statistics
    googleAnalytics = 'google_analytics',
    gemius = 'gemius'
}

export const cookieAllowed = (type: CookieTypes): boolean => {
    // Temp solution, should be removed with Magio Cookie notice in Q1 2023
    if (Device.isWeb && isMagioEnv) return false;
    if (!Device.isWeb || !isTMCZEnv) return true;

    return isScriptAllowedRec(type);
};

export const loadCookieConsent = (userId?: string | number): void => coComponent(userId);
